import script from "./RecipePage.vue?vue&type=script&setup=true&lang=js"
export * from "./RecipePage.vue?vue&type=script&setup=true&lang=js"

import "./RecipePage.vue?vue&type=style&index=0&id=3a17a7ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a17a7ec"]])

export default __exports__